export class RteTooltipInfo {

    static readonly dockLeft = "left";
    static readonly dockRight = "right";
    dock: string;
    message: string;
}